import React from 'react';
import { ProposalProduct } from '@trnsact/trnsact-shared-types/dist/generated';
import { Box, Stack, Typography } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import { S3_BUCKET_NAME } from 'config';

interface Props {
  product: ProposalProduct;
}

export const ProposalProductCardDocuments = ({ product }: Props) => {
  const documents = product?.aftermarketProduct?.documents;

  if (!documents?.length) return null;

  return documents.map(document => (
    <Box mt={1} key={document!.documentId}>
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <InsertDriveFileIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2" component="span">
          {document!.docName}
        </Typography>
        <DownloadIcon
          color="primary"
          fontSize="small"
          sx={{ cursor: 'pointer' }}
          onClick={() => window.open(`https://${S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${document!.source}`)}
        />
      </Stack>
    </Box>
  ));
};
